import api from "./axiosAPI";
import { formatDjangoDateTime } from "utils/dates";

const formatIfPresent = (value) => (value ? formatDjangoDateTime(value) : value);

const formatTripStopTimes = (stop = {}) => ({
    ...stop,
    original_scheduled_arrival_time: formatIfPresent(stop.original_scheduled_arrival_time),
    scheduled_arrival_time: formatIfPresent(stop.scheduled_arrival_time),
    estimated_arrival_time: formatIfPresent(stop.estimated_arrival_time),
    arrival_time: formatIfPresent(stop.arrival_time),
    departure_time: formatIfPresent(stop.departure_time),
});

const formatTripTimes = (trip = {}) => ({
    ...trip,
    created_at: formatIfPresent(trip.created_at),
    updated_at: formatIfPresent(trip.updated_at),
    started_at: formatIfPresent(trip.started_at),
    completed_at: formatIfPresent(trip.completed_at),
    stops: Array.isArray(trip.stops) ? trip.stops.map(formatTripStopTimes) : trip.stops,
});

export const tripsAPI = {
    getTrips: async (page, page_size = 10, filters = {}) => {
        try {
            const params = {
                ...filters,
                ...(page ? { page } : {}),
                ...(page_size ? { page_size } : {}),
            };
            const response = await api.get("/trips/", { params });
            const payload = response.data;
            if (Array.isArray(payload?.results)) {
                return {
                    ...payload,
                    results: payload.results.map(formatTripTimes),
                };
            }
            if (Array.isArray(payload)) {
                return payload.map(formatTripTimes);
            }
            return payload;
        } catch (error) {
            console.error("Error fetching trips:", error);
            throw error;
        }
    },
    getFilterOptions: async () => {
        try {
            const response = await api.get("/trips/filter-options/");
            return response.data;
        } catch (error) {
            console.error("Error fetching trip filter options:", error);
            throw error;
        }
    },
    // Add more API methods related to trips as needed
};
